import React, { useEffect, useState } from 'react'
import Breadcrumbs, { IBreadcrumb } from '../components/Breadcrumbs'
import Page from './components/Page'
import ItemsBasePage from '../features/items/ItemsBasePage'
import { useParams } from 'react-router-dom'
import NotFound from '../components/NotFound'
import WarehousesApp, { EmptyWarehouseModel, IWarehouseModel } from '../features/warehouses/WarehousesApp'
import { Skeleton } from '@mui/material'
import { useReturnAllWarehouses } from '../features/warehouses/warehousesSlice'
import { handleRequestError } from '../services/api'
import { useDispatch } from 'react-redux'

export default function Warehouse() {

    const dispatch = useDispatch()

    const params = useParams()
    const warehouseId = params.id ? Number(params.id) : 0

    const [loading, setLoading] = useState<boolean>(true)
    const [notFound, setNotFound] = useState<boolean>(false)
    const [warehouse, setWarehouse] = useState<IWarehouseModel>(EmptyWarehouseModel)

    const warehousesApp = new WarehousesApp()
    const warehouses = useReturnAllWarehouses()

    /**
     * Breadcrumbs
     */
    const breadcrumbs: IBreadcrumb[] = [
        {
            title: "Home",
            link: "/"
        },
        {
            title: "Warehouses",
            link: "/warehouses"
        },
        {
            title: warehouse.title,
        },
    ]

    /**
     * Load warehouse
     */
    useEffect(() => {
        
        if (warehouses.some(item => item.id === warehouseId)){
            const find = warehouses.find(item => item.id === warehouseId)
            
            if (find){
                setWarehouse(find)
                setNotFound(false)
            }else{
                setNotFound(true)
            }

            setLoading(false)
        }else{
            warehousesApp.singleInstanceDetails(warehouseId)
                .then(response => {
                    setWarehouse(response.data)
                    setLoading(false)
                    setNotFound(false)
                })
                .catch(error => {

                    switch(error.response.status){
                        case 404:
                            setNotFound(true)
                            break
                    }

                    handleRequestError(error, dispatch)
                })
        }

    }, [warehouseId])

    if (notFound){
        return(
            <Page>
                <div className="page-container-wrapper">
                    <NotFound title="Nothing found" message="This warehouse doesn't exist" />
                </div>
            </Page>
        )
    }

    return(
        <Page>
            <div className="inventory-page-container content-section-wrapper page-container-wrapper">
                
                <div className="page-container-head-box">
                    <div className="content-of-page-container-head-box">
                        <h1>{loading ? <Skeleton variant="text" width={150} /> : warehouse.title}</h1>

                        {loading ? (
                            <>
                                <Skeleton variant="text" width={50} />
                            </>
                        ): <Breadcrumbs breadcrumbs={breadcrumbs} />}
                    </div>
                </div>

                <div className="inventory-list">
                    {loading ? (
                        <>
                            <Skeleton variant="rectangular" width="100%" height={500} style={{ borderRadius: 15 }} />
                        </>
                    ) : <ItemsBasePage isInventoryPage customWarehouseId={warehouseId} />}
                </div>

            </div>
        </Page>
    )
}